import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetServicesDentalGuide,
	GetServicesDentalGuideModel,
	GetServicesDentalGuideParams,
} from 'domain/usecases';

export class RemoteGetServicesDentalGuide implements GetServicesDentalGuide {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetServicesDentalGuideModel>,
	) {}

	async get({
		signal,
		...params
	}: GetServicesDentalGuideParams): Promise<GetServicesDentalGuideModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
